import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'closingPackageUploaded',
    label: 'Closing Package Uploaded',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'creditPackageUploaded',
    label: 'Credit Package Uploaded',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const shipperMilestoneForm = {
  name: FormNames.POST_CLOSING,
  label: 'Shipper Milestone',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
